export default function() {
  function updateThemeUI(isDark: boolean): void {
    const btn = document.getElementById("btn-theme-toggle");
    if (btn) {
      btn.innerHTML = isDark ? "☀️ Mode clair" : "🌓 Mode sombre";
    }
    const mobileBtn = document.getElementById("btn-theme-toggle-mobile");
    if (mobileBtn) {
      mobileBtn.innerHTML = isDark ? "☀️" : "🌓";
      mobileBtn.title = isDark ? "Passer en mode clair" : "Passer en mode sombre";
    }
  }

  function initDarkMode(): void {
    const isDark = localStorage.getItem("absurde_dark_mode") === "true";
    if (isDark) {
      document.body.classList.add("dark-mode");
    }
    updateThemeUI(isDark);
  }

  (window as any).toggleDarkMode = () => {
    const isDark = document.body.classList.toggle("dark-mode");
    localStorage.setItem("absurde_dark_mode", String(isDark));
    updateThemeUI(isDark);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDarkMode);
  } else {
    initDarkMode();
  }
}
